import React from 'react'
import { Container, Row, Col } from 'reactstrap'

const Loading = () => (
  <div>
    <Container>
      <Row>
        <Col className='text-center'>
          <div className='loader' />
        </Col>
      </Row>
    </Container>
  </div>
)

export default Loading



// WEBPACK FOOTER //
// ./src/containers/loading.jsx